import { render, staticRenderFns } from "./HeaderConfig.vue?vue&type=template&id=4705f6de&scoped=true"
import script from "./HeaderConfig.vue?vue&type=script&lang=js"
export * from "./HeaderConfig.vue?vue&type=script&lang=js"
import style0 from "./HeaderConfig.vue?vue&type=style&index=0&id=4705f6de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705f6de",
  null
  
)

export default component.exports